<atn-display-value
  [label]="labelSg()"
  [type]="typeSg()"
  [value]="valueSg()"
  [readonly]="readonlySg()"
  (valueChange)="valueChange.emit($event)"
/>
